import type { FieldValues, Path } from "react-hook-form";
import styled from "styled-components";
import type { FieldOption } from "../../../form/Form.Parts";
import type { BaseProps } from "../../FormField.Parts";

// TEXT

// STYLES
export const RadioGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

// DATA

// TYPES
export type Props<
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
> = BaseProps<FormFields, FieldName, string> & {
  type: "radio";
  fieldOptions: FieldOption[];
};

// CONSTANTS

// FUNCTIONS

// ASSETS
